/** The two facts the voice engine reads from session descriptions. */

/**
 * Session id from the SDP origin line (`o=- <id> <version> IN IP4 ...`). It stays the same
 * for the whole life of an RTCPeerConnection and differs between connections, so a
 * description with a new id means that the other side started over with a fresh one.
 */
export function sdpSessionId(sdp: string | undefined): string | null {
  if (!sdp) return null;
  return /^o=\S+ (\S+) /m.exec(sdp)?.[1] ?? null;
}

/** ICE username fragment of the (first) media section; it changes on every ICE restart. */
export function sdpIceUfrag(sdp: string | undefined): string | null {
  if (!sdp) return null;
  return /^a=ice-ufrag:(\S+)/m.exec(sdp)?.[1] ?? null;
}
